import React from 'react';
import { H5 } from '../../../AbstractElements';
import ReactApexChart from 'react-apexcharts';
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';
import { OrderStatus } from '../../../Constant';
import { ApexLineChartOption, ApexLineChartSeries } from '../../../Data/Widgets/Chart/ChartData';
import { FiShoppingBag } from 'react-icons/fi';

const OrderStatus2 = () => {
  return (
    <>
      <Col xl='7' lg='12' className='box-col-7'>
        <Card>
          <CardHeader className='pb-0'>
            <Row>
              <Col xs='9'>
                <H5>{OrderStatus}</H5>
              </Col>
              <Col xs='3' className='text-end'>
                <FiShoppingBag style={{ width: '20px', height: '20px' }} className='text-muted' />
              </Col>
            </Row>
          </CardHeader>
          <CardBody>
            <div className='chart-container'>
              <div id='linechart'>
                <ReactApexChart options={ApexLineChartOption.options} height='350' series={ApexLineChartSeries.series} type='line' />
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>
    </>
  );
};
export default OrderStatus2;
